// Header: on hover-capable screens the Shop dropdown opens on hover, unfolding downward with
// its links settling in one after another. Touch screens keep tap-to-open.
// Listeners live on the document so a re-rendered header (theme editor, live reload) keeps working.
(() => {
  if (!window.gsap) return;
  const hoverable = matchMedia('(hover: hover)');
  const speed = matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 1;
  // Negative insets leave room for the drop shadow and the hover bridge above the panel.
  const shut = 'inset(-30px -30px 100% -30px)', shown = 'inset(-30px -30px -30px -30px)';
  const menuOf = el => el instanceof Element ? el.closest('.talent-navigation') : null;

  const open = menu => {
    if (!hoverable.matches) return;
    const panel = menu.querySelector('nav');
    menu._thTl?.kill();
    menu.open = true;
    menu.classList.add('th-open');
    menu._thTl = gsap.timeline()
      .fromTo(panel, {clipPath: shut}, {clipPath: shown, duration: 0.55 * speed, ease: 'expo.out'}, 0)
      .fromTo(panel.querySelectorAll('a'), {autoAlpha: 0, y: -6},
        {autoAlpha: 1, y: 0, duration: 0.45 * speed, ease: 'power3.out', stagger: 0.05 * speed}, 0.08 * speed);
  };
  const close = menu => {
    if (!hoverable.matches || !menu.open) return;
    const panel = menu.querySelector('nav');
    menu._thTl?.kill();
    menu.classList.remove('th-open');
    menu._thTl = gsap.timeline({onComplete() {
      menu.open = false;
      gsap.set([panel, ...panel.querySelectorAll('a')], {clearProps: 'all'});
    }}).to(panel, {clipPath: shut, duration: 0.3 * speed, ease: 'power2.in'});
  };

  // Enter/leave the whole menu (ignore moves between its own children).
  document.addEventListener('pointerover', e => {
    const menu = menuOf(e.target);
    if (menu && !menu.contains(e.relatedTarget)) open(menu);
  });
  document.addEventListener('pointerout', e => {
    const menu = menuOf(e.target);
    if (menu && !menu.contains(e.relatedTarget)) close(menu);
  });
  document.addEventListener('focusin', e => {
    const menu = menuOf(e.target);
    if (menu && !menu.open) open(menu);
  });
  document.addEventListener('focusout', e => {
    const menu = menuOf(e.target);
    if (menu && !menu.contains(e.relatedTarget)) close(menu);
  });
  document.addEventListener('click', e => {
    const menu = menuOf(e.target);
    if (!menu) return;
    // Keep the native summary toggle from fighting the hover state.
    if (e.target.closest('summary') && hoverable.matches) e.preventDefault();
    // Picking a link (e.g. an on-page section) closes the panel.
    else if (e.target.closest('nav a')) close(menu);
  });
})();
